import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { filter, map } from 'lodash';
import { Stack } from 'react-bootstrap';

import { loggerCommands, toggleTriggerOptions } from '../constants';
import { updatedLoggerCommands } from '../helpers';
import { useDataLoggerHistory } from '../useDataLoggerHistory';
import StopBlackboxLoggerModal from './StopBlackboxLoggerModal';

const BlackboxLoggerComponent = ({ model, actions, asset }) => {
    const { t: translate } = useTranslation();
    const [showStopConfirmationModal, setShowStopConfirmationModal] = useState(false);
    const {
        specialLoggerCommands,
        lastActivityStatus,
        currentLastActivityStatus
    } = model;
    const filteredBlackboxCommands = filter(specialLoggerCommands, blackboxCommand => blackboxCommand?.commandType === loggerCommands.STARTSTOP);

    const triggerBlackboxLogger = (selectedTriggerOption, loggerCommand) => {
        const [triggerCommandId, stopCommandId] = loggerCommand.commandId;
        if (selectedTriggerOption === toggleTriggerOptions.TRIGGER) {
            actions?.subscribeUnsubscribeDataLoggerCommands({
                assetId: asset?.id,
                loggerType: loggerCommand?.loggerType,
                commandId: triggerCommandId,
                commandDisplayName: loggerCommand?.commandDisplayName
            });
        } else if (selectedTriggerOption === toggleTriggerOptions.STOP) {
            actions?.subscribeUnsubscribeDataLoggerCommands({
                assetId: asset?.id,
                loggerType: loggerCommand?.loggerType,
                commandId: stopCommandId,
                commandDisplayName: loggerCommand?.commandDisplayName
            });
        }
    };

    const updatedBlackboxCommands = updatedLoggerCommands(filteredBlackboxCommands);

    const {
        isCurrentActivity,
        setIsCurrentActivity,
        dataLoggerHistoryTooltip,
        currentDataLoggerHistoryTooltip,
    } = useDataLoggerHistory(lastActivityStatus, currentLastActivityStatus);

    const handleOpenStopBlackboxModal = () => {
        setShowStopConfirmationModal(true);
    };

    const handleStopBlackboxLogger = (blackboxCommand) => {
        triggerBlackboxLogger(toggleTriggerOptions.STOP, blackboxCommand);
        setIsCurrentActivity(true);
        setShowStopConfirmationModal(false);
    };

    const handleSelection = (selectedTriggerOption, blackboxCommand) => {
        if (selectedTriggerOption === toggleTriggerOptions.TRIGGER) {
            triggerBlackboxLogger(selectedTriggerOption, blackboxCommand);
            setIsCurrentActivity(true);
        } else {
            handleOpenStopBlackboxModal();
        }
    };

    return (
        map(updatedBlackboxCommands, (blackboxCommand, i) => {
            return (
                <>
                    <Stack direction='horizontal' key={i}>
                        <div className='data-logger__type py-2' id={`blackbox-command-display-name-${i}`}>{blackboxCommand?.commandDisplayName}</div>
                        <div className='py-1 d-flex ms-auto' id={`blackbox-command-status-${i}`}>
                            {
                                blackboxCommand?.commandType === loggerCommands.STARTSTOP &&
                                <div className='d-flex ms-auto blackbox-button-group' id={`blackbox-button-group-${i}`}>
                                    <button
                                        className='blackbox-button blackbox-button--start'
                                        onClick={() => handleSelection(toggleTriggerOptions.TRIGGER, blackboxCommand)}
                                        id={`trigger-blackbox-button-${i}`}
                                    >
                                        {translate('ABB.Powertrain.Frontend.dataLoggerTriggerLabel')}
                                    </button>
                                    <button
                                        className='blackbox-button blackbox-button--stop'
                                        onClick={() => handleSelection(toggleTriggerOptions.STOP, blackboxCommand)}
                                        id={`stop-blackbox-button-${i}`}
                                    >
                                        {translate('ABB.Powertrain.Frontend.dataLoggerStopLabel')}
                                    </button>
                                    <div className='ml-2' id={`blackbox-logger-history-tooltip-${i}`}>
                                        {isCurrentActivity ? currentDataLoggerHistoryTooltip() : dataLoggerHistoryTooltip()}
                                    </div>
                                </div>
                            }
                        </div>
                    </Stack>

                    <StopBlackboxLoggerModal
                        show={showStopConfirmationModal}
                        close={() => setShowStopConfirmationModal(false)}
                        onConfirm={() => {
                            handleStopBlackboxLogger(blackboxCommand);
                        }}
                    />
                </>
            );
        })
    );
};

BlackboxLoggerComponent.propTypes = {
    model: PropTypes.object,
    actions: PropTypes.object,
    asset: PropTypes.object
};

export default BlackboxLoggerComponent;
